import { render, staticRenderFns } from "./VPBank.vue?vue&type=template&id=26a7377c&scoped=true&"
import script from "./VPBank.vue?vue&type=script&lang=js&"
export * from "./VPBank.vue?vue&type=script&lang=js&"
import style0 from "./VPBank.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VPBank.vue?vue&type=style&index=1&id=26a7377c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a7377c",
  null
  
)

export default component.exports